function createSizeDropdown() {
  const sizeFieldset = document.querySelector('fieldset[data-option-id*="apple-watch-case-size"]');
  if (!sizeFieldset) return;
  
  // Check if dropdown already exists to avoid duplicates
  const existingSelect = sizeFieldset.querySelector('select.custom-size-dropdown');
  if (existingSelect) return;
  
  // Create select element
  const select = document.createElement('select');
  select.className = 'custom-size-dropdown';
  select.style.cssText = 'width: 100%; padding: 12px; border: 1px solid #d1d5db; border-radius: 6px; font-size: 14px; background-color: white; cursor: pointer; margin-top: 8px;';
  
  // Get all radio inputs
  const radios = sizeFieldset.querySelectorAll('input[type="radio"]');
  
  // Create options from radio buttons
  radios.forEach((radio) => {
    const option = document.createElement('option');
    const isAvailable = radio.getAttribute('data-option-available') === 'true';
    
    option.value = radio.value;
    option.textContent = radio.value + (isAvailable ? '' : ' - Out of stock');
    
    // Disable unavailable options
    if (!isAvailable) {
      option.disabled = true;
    }
    
    if (radio.checked) option.selected = true;
    select.appendChild(option);
  });
  
  // Add change handler 
  select.addEventListener('change', function() {
    const selectedRadio = Array.from(radios).find(r => r.value === this.value);
    if (selectedRadio) selectedRadio.click();
  });
  
  // Insert after legend
  const legend = sizeFieldset.querySelector('legend');
  legend.after(select);
}

// Run on initial load
//document.addEventListener('DOMContentLoaded', createSizeDropdown);

// Watch for changes to the variant picker
const observer = new MutationObserver(function(mutations) {
  createSizeDropdown();
});

// Start observing when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  const variantPicker = document.querySelector('[data-block-id*="variant_picker"]') || document.querySelector('.product-form');
  if (variantPicker) {
    observer.observe(variantPicker, {
      childList: true,
      subtree: true
    });
  }
});
